var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cd3e61e8cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.625 37.5 L 258.375 37.5 L 258.375 337.5 L 116.625 337.5 Z M 116.625 37.5 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd3e61e8cc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#238bed",
    d: "M 225.671875 87.257812 L 258.375 87.257812 L 258.375 37.953125 L 216.617188 37.953125 L 216.617188 38.140625 C 161.714844 40.152344 150.394531 70.90625 149.453125 103.417969 L 149.328125 103.417969 L 149.328125 137.628906 L 116.625 137.628906 L 116.625 186.996094 L 149.328125 186.996094 L 149.328125 337.046875 L 208 337.046875 L 208 186.996094 L 250.074219 186.996094 L 258.375 137.628906 L 208 137.628906 L 208 107.003906 C 208 96.125 215.296875 87.257812 225.671875 87.257812 Z M 225.671875 87.257812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.1207ad62380480c48fe66bcbe24458ec.svg";
export { ForwardRef as ReactComponent };